var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81655 2.72869C10.389 2.15588 11.3175 2.15549 11.8904 2.72782L13.2707 4.10654C13.8439 4.6791 13.8443 5.60797 13.2716 6.18102L6.75579 12.7004C6.55151 12.9048 6.2914 13.0443 6.00812 13.1013L3.09746 13.6878C2.87855 13.7319 2.6521 13.6635 2.49424 13.5056C2.33638 13.3476 2.26809 13.1211 2.31232 12.9022L2.89986 9.995C2.95699 9.7123 3.0962 9.45272 3.30009 9.24872L9.81655 2.72869ZM10.9482 3.67116C10.8961 3.61913 10.8117 3.61917 10.7596 3.67124L9.85281 4.57855L11.4209 6.14661L12.3285 5.23847C12.3806 5.18637 12.3805 5.10193 12.3284 5.04988L10.9482 3.67116ZM10.4783 7.08967L8.91026 5.52162L4.24316 10.1913C4.22462 10.2098 4.21197 10.2334 4.20677 10.2591L3.81807 12.1825L5.74475 11.7943C5.77051 11.7891 5.79415 11.7764 5.81272 11.7578L10.4783 7.08967Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.181c641ef3f06dae35fbacab8cad03d4.svg";
export { ForwardRef as ReactComponent };